export var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["Active"] = "Active";
    MembershipStatus["Trial"] = "Trial";
    MembershipStatus["Expiring"] = "Expiring";
    MembershipStatus["Inactive"] = "Inactive";
    MembershipStatus["Temporary"] = "Temporary";
})(MembershipStatus || (MembershipStatus = {}));
export var ContinuousMembershipStatus;
(function (ContinuousMembershipStatus) {
    ContinuousMembershipStatus["Full"] = "Full";
    ContinuousMembershipStatus["Partial"] = "Partial";
    ContinuousMembershipStatus["None"] = "None";
})(ContinuousMembershipStatus || (ContinuousMembershipStatus = {}));
//# sourceMappingURL=MembershipStatus.js.map